export function getLocale() {
  return localStorage.getItem('locale')
}

export function setLocale(newLocale) {
  return localStorage.setItem('locale', newLocale)
}
